"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _addCloudDisk = _interopRequireDefault(require("@/views/product/components/addCloudDisk.vue"));
var _vuedraggable = _interopRequireDefault(require("vuedraggable"));
var _product = require("@/api/product");
var _utils = require("@/utils");
var _product2 = _interopRequireDefault(require("@/mixins/product"));
var _default3 = require("../creatProduct/default");
var _TableHeadList = require("../creatProduct/TableHeadList.js");
var _productEnums = require("@/enums/productEnums");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'creatAttr',
  mixins: [_product2.default],
  //此js存放团购券的部分函数方法
  components: {
    draggable: _vuedraggable.default,
    addCloudDisk: _addCloudDisk.default
  },
  computed: {
    tableAttrValue: function tableAttrValue() {
      var obj = Object.assign({}, _default3.defaultObj.attrValueList[0]);
      delete obj.isShow;
      delete obj.image;
      delete obj.brokerage;
      delete obj.brokerageTwo;
      delete obj.cdkeyId;
      delete obj.expand;
      delete obj.cdkeyLibraryName;
      if (!this.formValidate.isPaidMember) {
        delete obj.vipPrice;
      } else {
        obj.vipPrice = Object.assign({}, _default3.defaultObj.attrValueList[0]).vipPrice;
      }
      if (this.formValidate.type === 2) {
        delete obj.itemNumber;
      }
      if (this.formValidate.type === 5) {
        delete obj.volume;
        delete obj.weight;
        delete obj.itemNumber;
      }
      if (this.formValidate.type === 6) {
        delete obj.volume;
        delete obj.weight;
        delete obj.itemNumber;
      }
      return obj;
    }
  },
  data: function data() {
    return {
      OrderSecondTypeEnum: _productEnums.OrderSecondTypeEnum,
      carMytabIndex: 0,
      carMytabName: '',
      cdkeyId: null,
      //卡密库id
      cdkeyLibraryInfo: null,
      //卡密库对象
      cloudDisk: '',
      //云盘地址
      showAll: false,
      formValidate: this.value,
      ruleList: [],
      // // 规格数据
      formDynamic: {
        attrsName: '',
        attrsVal: ''
      },
      formDynamics: {
        ruleName: '',
        ruleValue: []
      },
      tableFrom: {
        page: 1,
        limit: 9999,
        keywords: ''
      },
      columnsInstalM: [],
      changeAttrValue: '',
      //修改的规格值
      currentIndex: 0,
      canSel: true,
      // 规格图片添加判断
      tableKey: 0
    };
  },
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 生成规格表格中的头部标题
    manyTabDate: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    //生成规格的表格中填写的值
    formThead: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    //生成表格的头部标题
    manyTabTit: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    // 单规格
    OneattrValue: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 多规格
    ManyAttrValue: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    //批量添加规格
    oneFormBatch: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  watch: {
    formValidate: {
      handler: function handler(newVal) {
        this.$emit('input', newVal);
      },
      deep: true
    }
  },
  mounted: function mounted() {
    if (this.formValidate.specType) this.productGetRule(); //加载团购券规格选项
    if (this.formValidate.specType && (this.$route.params.id && this.$route.params.id != 0 || this.$route.params.isCopy === '1')) {
      this.formValidate.attrs = this.formValidate.attrList.map(function (i) {
        return {
          value: i.attributeName,
          detail: i.optionList.map(function (val) {
            return {
              value: val.optionName,
              image: val.image
            };
          }),
          add_pic: i.isShowImage ? 1 : 0
        };
      });
      this.createBnt = true;
      // 采集团购券只有规格，没有规格列表，这里判断使用 方法，attrValueList.length为0，走生成规格方法
      if (this.formValidate.attrValueList.length) {
        this.generateHeader(this.formValidate.attrs);
      } else {
        this.generateAttr(this.formValidate.attrs);
      }
    }
  },
  methods: {
    handleShowPop: function handleShowPop(index) {
      this.$refs['inputRef_' + index][0].focus();
    },
    // 删除属性
    handleRemove2: function handleRemove2(item, index, val) {
      item.splice(index, 1);
      this.delAttrTable(val);
    },
    // 新增规格
    handleAddRole: function handleAddRole() {
      var data = {
        value: this.formDynamic.attrsName,
        add_pic: 0,
        detail: []
      };
      this.formValidate.attrs.push(data);
    },
    // 规格名称改变
    attrChangeValue: function attrChangeValue(i, val) {
      var _this2 = this;
      if (val.trim().length && this.formValidate.attrs[i].detail.length) {
        this.generateHeader(this.formValidate.attrs);
        if (this.ManyAttrValue.length) {
          this.ManyAttrValue.map(function (item, i) {
            if (i > 0) {
              if (Object.keys(item.attrValueShow).includes(_this2.changeAttrValue)) {
                item.attrValueShow[val] = item.attrValueShow[_this2.changeAttrValue];
                item[val] = item[_this2.changeAttrValue];
                delete item.attrValueShow[_this2.changeAttrValue];
                delete item[_this2.changeAttrValue];
              }
            }
          });
          this.changeAttrValue = val;
        }
      } else {
        this.generateAttr(this.formValidate.attrs);
      }
    },
    // 规格值改变
    attrDetailChangeValue: function attrDetailChangeValue(val, i) {
      var _this3 = this;
      if (this.ManyAttrValue.length) {
        var key = this.formValidate.attrs[i].value;
        this.ManyAttrValue.map(function (item, i) {
          if (i > 0) {
            if (Object.keys(item.attrValueShow).includes(key) && item.attrValueShow[key] === _this3.changeAttrValue) {
              item.attrValueShow[key] = val;
              var index = item.attr_arr.findIndex(function (item) {
                return item === _this3.changeAttrValue;
              });
              item.attr_arr[index] = val;
            }
          }
        });
        this.changeAttrValue = val;
      } else {
        this.generateAttr(this.formValidate.attrs, 1);
      }
      this.$nextTick(function () {
        _this3.$emit('changeManyAttrValue', _toConsumableArray(_this3.ManyAttrValue));
      });
    },
    changeCurrentIndex: function changeCurrentIndex(i) {
      this.currentIndex = i;
    },
    // 新增一条属性
    addOneAttr: function addOneAttr(val, val2) {
      this.generateAttr(this.formValidate.attrs, val2);
    },
    handleFocus: function handleFocus(val) {
      this.changeAttrValue = val;
    },
    handleBlur: function handleBlur() {
      this.changeAttrValue = '';
    },
    // 规格拖拽排序后
    onMoveSpec: function onMoveSpec() {
      this.generateAttr(this.formValidate.attrs);
    },
    handleRemoveImg: function handleRemoveImg(item) {
      item.image = '';
    },
    // 合并单元格
    objectSpanMethod: function objectSpanMethod(_ref) {
      var row = _ref.row,
        column = _ref.column,
        rowIndex = _ref.rowIndex,
        columnIndex = _ref.columnIndex;
      if (columnIndex === 0 && rowIndex > 0) {
        var lable = column.label;
        //这里判断第几列需要合并
        var tagFamily = this.ManyAttrValue[rowIndex].attrValueShow[lable];
        var index = this.ManyAttrValue.findIndex(function (item, index) {
          if (index > 0) return item.attrValueShow[lable] == tagFamily;
        });
        if (rowIndex == index) {
          var len = 1;
          for (var i = index + 1; i < this.ManyAttrValue.length; i++) {
            if (this.ManyAttrValue[i].attrValueShow[lable] !== tagFamily) {
              break;
            }
            len++;
          }
          return {
            rowspan: len,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    /*
     * 生成属性
     * @param {Array} data 规格数据
     * */
    generateAttr: function generateAttr(data, val) {
      var _this4 = this;
      // 判断该段Js执行时间
      this.generateHeader(data);
      var combinations = this.generateCombinations(data);
      var rows = combinations.map(function (combination) {
        var row = {
          attr_arr: combination,
          attrValueShow: {},
          image: '',
          price: 0.01,
          vipPrice: 0.01,
          cost: 0.01,
          otPrice: 0.01,
          barCode: '',
          itemNumber: '',
          stock: 0,
          weight: 0,
          volume: 0,
          brokerage: 0,
          brokerageTwo: 0,
          cdkeyId: null,
          cdkeyLibraryName: '',
          expand: '',
          isShow: true
        };
        // 判断团购券类型是卡密/优惠券
        var virtualType = _this4.formValidate.type;
        if (virtualType == _this4.OrderSecondTypeEnum.CardPassword) {
          //卡密
          _this4.$set(row, 'expand', '');
        } else if (virtualType == _this4.OrderSecondTypeEnum.CloudDrive) {
          //云盘
          _this4.$set(row, 'cdkey', {});
          _this4.$set(row, 'cdkeyId', '');
        }
        for (var i = 0; i < combination.length; i++) {
          var value = combination[i];
          _this4.$set(row, data[i].value, value);
          _this4.$set(row, 'title', data[i].value);
          _this4.$set(row, 'key', data[i].value);
          _this4.$set(row.attrValueShow, data[i].value, value);
          // 如果manyFormValidate中存在该属性值，则赋值
          for (var k = 0; k < _this4.ManyAttrValue.length; k++) {
            var manyItem = _this4.ManyAttrValue[k];
            // 对比两个数组是否完全相等
            if (k > 0 && manyItem.attr_arr && (0, _utils.arraysEqual)(manyItem.attr_arr, combination)) {
              Object.assign(row, {
                price: manyItem.price,
                cost: manyItem.cost,
                otPrice: manyItem.otPrice,
                stock: manyItem.stock,
                image: manyItem.image,
                sku: manyItem.sku || '',
                weight: manyItem.weight || '',
                isDefault: manyItem.isDefault || 0,
                volume: manyItem.volume || 0,
                barCode: manyItem.barCode || '',
                itemNumber: manyItem.itemNumber || '',
                brokerage: manyItem.brokerage,
                brokerageTwo: manyItem.brokerageTwo,
                vipPrice: manyItem.vipPrice
              });
            } else if (k > 0 && manyItem.attr_arr.length && data[i].add_pic && combination.includes(val)) {
              // data[i].detail中的value是规格值 存在与 manyItem.attr_arr 中的某一项
              data[i].detail.map(function (e, ii) {
                combination.includes(e.value) && _this4.$set(row, 'image', e.image);
              });
            }
          }
        }
        return row;
      });
      this.$nextTick(function () {
        // rows数组第一项 新增默认数据 oneFormBatch
        _this4.$emit('changeManyAttrValue', [].concat(_toConsumableArray(_this4.oneFormBatch), _toConsumableArray(rows)));
      });
    },
    //分佣设置 会员团购券操作
    changeAttrVal: function changeAttrVal() {
      this.generateHeader(this.formValidate.attrs);
    },
    // 生成团购券规格表头
    generateHeader: function generateHeader(data) {
      var specificationsColumns = data.map(function (item) {
        return {
          title: item.value,
          key: item.value,
          minWidth: 120,
          fixed: 'left'
        };
      });
      var arr;
      //云盘团购券
      if (this.formValidate.type == this.OrderSecondTypeEnum.CloudDrive) {
        // 开启分佣设置
        if (this.formValidate.isSub && this.formValidate.isPaidMember) {
          arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.commissionTableHead), _toConsumableArray(_TableHeadList.vipPriceTableHead), _toConsumableArray(_TableHeadList.VirtualTableHead));
        } else if (this.formValidate.isSub) {
          arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.commissionTableHead), _toConsumableArray(_TableHeadList.VirtualTableHead));
        } else if (this.formValidate.isPaidMember) {
          //开启会员
          arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.vipPriceTableHead), _toConsumableArray(_TableHeadList.VirtualTableHead));
        } else {
          arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.VirtualTableHead));
        }
        // 找到slot 等于 fictitious 将title改为规格名称
        this.formValidate.header.map(function (item) {
          if (item.slot === 'fictitious') {
            item.title = '云盘设置';
          }
        });
      } else if (this.formValidate.type == this.OrderSecondTypeEnum.CardPassword) {
        //卡密团购券
        // 开启分佣设置
        if (this.formValidate.isSub && this.formValidate.isPaidMember) {
          arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.commissionTableHead), _toConsumableArray(_TableHeadList.vipPriceTableHead), _toConsumableArray(_TableHeadList.VirtualTableHead2));
        } else if (this.formValidate.isSub) {
          arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.commissionTableHead), _toConsumableArray(_TableHeadList.VirtualTableHead2));
        } else if (this.formValidate.isPaidMember) {
          //开启会员
          arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.vipPriceTableHead), _toConsumableArray(_TableHeadList.VirtualTableHead2));
        } else {
          arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.VirtualTableHead2));
        }
      } else if (this.formValidate.type == this.OrderSecondTypeEnum.Fictitious) {
        //虚拟团购券
        // 开启分佣设置
        if (this.formValidate.isSub && this.formValidate.isPaidMember) {
          arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.commissionTableHead), _toConsumableArray(_TableHeadList.vipPriceTableHead), _toConsumableArray(_TableHeadList.FictitiousTableHead));
        } else if (this.formValidate.isSub) {
          arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.commissionTableHead), _toConsumableArray(_TableHeadList.FictitiousTableHead));
        } else if (this.formValidate.isPaidMember) {
          //开启会员
          arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.vipPriceTableHead), _toConsumableArray(_TableHeadList.FictitiousTableHead));
        } else {
          arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.FictitiousTableHead));
        }
      } else {
        // 开启分佣设置
        if (this.formValidate.isSub && this.formValidate.isPaidMember) {
          arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.commissionTableHead), _toConsumableArray(_TableHeadList.vipPriceTableHead), _toConsumableArray(_TableHeadList.GoodsTableHead));
        } else if (this.formValidate.isSub) {
          arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.commissionTableHead), _toConsumableArray(_TableHeadList.GoodsTableHead));
        } else if (this.formValidate.isPaidMember) {
          //开启会员
          arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.vipPriceTableHead), _toConsumableArray(_TableHeadList.GoodsTableHead));
        } else {
          arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.GoodsTableHead));
        }
      }
      this.$set(this.formValidate, 'header', arr);
      this.tableKey += 1;
      this.columnsInstalM = arr;
    },
    // 生成规格组合
    generateCombinations: function generateCombinations(arr) {
      var _this5 = this;
      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      if (arr.length === 0) {
        return [prefix];
      }
      var _arr = _toArray(arr),
        first = _arr[0],
        rest = _arr.slice(1);
      return first.detail.flatMap(function (detail) {
        return _this5.generateCombinations(rest, [].concat(_toConsumableArray(prefix), [detail.value]));
      });
    },
    // 另存为模板
    handleSaveAsTemplate: function handleSaveAsTemplate() {
      var _this6 = this;
      this.$prompt('', '请输入模板名称', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValidator: function inputValidator(value) {
          if (value === null) {
            return '输入不能为空';
          }
          if (value.length > 30) return '输入限制30字以内';
        }
      }).then(function (_ref2) {
        var value = _ref2.value;
        var spec = _this6.formValidate.attrs.map(function (item) {
          return {
            value: item.value,
            detail: item.detail.map(function (e) {
              return e.value;
            })
          };
        });
        var data = {
          id: 0,
          ruleName: value,
          ruleValue: JSON.stringify(spec)
        };
        (0, _product.attrCreatApi)(data).then(function (res) {
          _this6.$message.success('提交成功');
          _this6.productGetRule();
          _this6.clear();
          _this6.loading = false;
          _this6.loadingBtn = false;
        }).catch(function () {
          _this6.loading = false;
          _this6.loadingBtn = false;
        });
      }).catch(function () {});
    },
    // 在规格中选择规格图片
    handleSelImg: function handleSelImg(item) {
      var _this = this;
      this.$modalUpload(function (img) {
        if (!img) return;
        item.image = img[0].sattDir;
        _this.changeSpecImg([item.value], img[0].sattDir);
      }, '1', 'content');
    },
    changeSpecImg: function changeSpecImg(arr, img) {
      var _this7 = this;
      // 判断是否存在规格图
      var isHas = false;
      for (var i = 1; i < this.ManyAttrValue.length; i++) {
        var item = this.ManyAttrValue[i];
        if (item.image && this.isSubset(item.attr_arr, arr)) {
          isHas = true;
          break;
        }
      }
      if (isHas) {
        this.$confirm('可以同步修改下方该规格图片，确定要替换吗？', '提示', {
          confirmButtonText: '替换',
          cancelButtonText: '暂不',
          type: 'warning'
        }).then(function () {
          var _iterator = _createForOfIteratorHelper(_this7.ManyAttrValue),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var val = _step.value;
              if (_this7.isSubset(val.attr_arr, arr)) {
                _this7.$set(val, 'image', img);
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }).catch(function () {});
      } else {
        var _iterator2 = _createForOfIteratorHelper(this.ManyAttrValue),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var val = _step2.value;
            if (this.isSubset(val.attr_arr, arr)) {
              this.$set(val, 'image', img);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    },
    // 规格图片添加开关
    addPic: function addPic(e, i) {
      var _this8 = this;
      if (e) {
        this.formValidate.attrs.map(function (item, ii) {
          if (ii !== i) {
            _this8.$set(item, 'add_pic', 0);
          }
        });
        this.canSel = false;
      } else {
        this.canSel = true;
      }
    },
    // 生成列表 行 列 数据
    tableCellClassName: function tableCellClassName(_ref3) {
      var row = _ref3.row,
        column = _ref3.column,
        rowIndex = _ref3.rowIndex,
        columnIndex = _ref3.columnIndex;
      //注意这里是解构
      //利用单元格的 className 的回调方法，给行列索引赋值
      row.index = rowIndex || '';
      column.index = columnIndex;
    },
    //返佣输入
    keyupEventBrokerage: function keyupEventBrokerage(val, index, num) {
      switch (num) {
        case 1:
          this.oneFormBatch[index][val] = this.oneFormBatch[index][val] > 0 ? parseInt(this.oneFormBatch[index][val]) : 0;
          break;
        case 2:
          this.OneattrValue[index][val] = this.OneattrValue[index][val] > 0 ? parseInt(this.OneattrValue[index][val]) : 0;
          break;
        default:
          this.ManyAttrValue[index][val] = this.ManyAttrValue[index][val] > 0 ? parseInt(this.ManyAttrValue[index][val]) : 0;
      }
    },
    // 添加规则；
    addRule: function addRule() {
      var _this = this;
      this.$modalAttr(this.formDynamics, function () {
        _this.productGetRule();
      });
    },
    // 选择规格
    onChangeSpec: function onChangeSpec(num) {
      if (num) {
        this.productGetRule();
        if (this.$route.params.id != 0) this.formValidate.attrs = [];
      } else {
        this.formValidate.attrs = [];
        this.formValidate.attrList = [];
      }
    },
    // 选择属性确认
    confirm: function confirm(name) {
      var _this9 = this;
      this.createBnt = true;
      this.canSel = true;
      this.formValidate.selectRule = name;
      if (!this.formValidate.selectRule) {
        return this.$message.warning('请选择属性');
      }
      var dataAttrList = [];
      var dataAttrs = [];
      this.ruleList.forEach(function (item) {
        if (item.ruleName === _this9.formValidate.selectRule) {
          item.ruleValue.forEach(function (i) {
            dataAttrList.push({
              attributeName: i.value,
              optionList: i.detail.map(function (val) {
                return {
                  optionName: val,
                  image: '',
                  sort: 0
                };
              }),
              id: 0,
              isShowImage: false,
              sort: i + 1
            });
            dataAttrs.push({
              value: i.value,
              detail: i.detail.map(function (val) {
                return {
                  value: val,
                  image: ''
                };
              }),
              id: 0,
              add_pic: 0,
              sort: i + 1
            });
          });
        }
        _this9.formValidate.attrList = dataAttrList;
        _this9.formValidate.attrs = dataAttrs;
      });
      // this.attrs.map((item, ii) => {
      //   this.$set(item, 'isShowImage', false);
      // });
      // this.canSel = true;
      this.generateAttr(this.formValidate.attrs);
    },
    // 获取团购券属性模板；
    productGetRule: function productGetRule() {
      var _this0 = this;
      (0, _product.templateListApi)(this.tableFrom).then(function (res) {
        var list = res.list;
        for (var i = 0; i < list.length; i++) {
          list[i].ruleValue = JSON.parse(list[i].ruleValue);
        }
        _this0.ruleList = list;
      });
    },
    // 删除表格中的属性
    delAttrTable: function delAttrTable(val) {
      for (var i = 0; i < this.ManyAttrValue.length; i++) {
        var item = this.ManyAttrValue[i];
        if (item.attr_arr && item.attr_arr.includes(val)) {
          this.ManyAttrValue.splice(i, 1);
          i--;
        }
      }
    },
    isSubset: function isSubset(arr1, arr2) {
      // 将数组转换为 Set，以便进行高效的包含检查
      var set1 = new Set(arr1);
      var set2 = new Set(arr2);

      // 检查 set2 中的每个元素是否都在 set1 中
      var _iterator3 = _createForOfIteratorHelper(set2),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var elem = _step3.value;
          if (!set1.has(elem)) {
            return false;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return true;
    },
    // 切换默认选中规格
    changeDefaultSelect: function changeDefaultSelect(e, index) {
      this.$emit('changeDefault', e, index);
      // 一个开启 其他关闭
      // this.ManyAttrValue.map((item, i) => {
      //   if (i !== index) {
      //     item.isDefault = false;
      //   }
      // });
      // if (e) this.ManyAttrValue[index].isShow = true;
    },
    // 改变是否显示
    changeDefaultShow: function changeDefaultShow(index) {
      // 如果默认选中开启 则不可隐藏
      if (this.ManyAttrValue[index].isDefault === true) {
        this.ManyAttrValue[index].isShow = true;
        this.$message.error('默认规格不可隐藏');
      }
    },
    // 清空批量规格信息
    batchDel: function batchDel() {
      this.$emit('handleBatchDel');
    },
    // 批量添加
    batchAdd: function batchAdd() {
      var _this1 = this;
      var arr = [];
      var _iterator4 = _createForOfIteratorHelper(this.formValidate.attrs),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var val = _step4.value;
          if (this.oneFormBatch[0][val.value]) {
            arr.push(this.oneFormBatch[0][val.value]);
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      this.ManyAttrValue.forEach(function (val) {
        if (val.attrValueShow) {
          if (arr.length) {
            var attrVal = val.attrValueShow;
            //   let data = Object.values(val.attrValueShow).map((item) => item.val);
            if (_this1.isSubset(Object.values(attrVal), arr)) {
              _this1.batchData(val);
            }
          } else {
            _this1.batchData(val);
          }
        }
      });
    },
    // 批量数据
    batchData: function batchData(val) {
      if (this.oneFormBatch[0].image) this.$set(val, 'image', this.oneFormBatch[0].image);
      if (this.oneFormBatch[0].price > 0) this.$set(val, 'price', this.oneFormBatch[0].price);
      if (this.oneFormBatch[0].cost > 0) this.$set(val, 'cost', this.oneFormBatch[0].cost);
      if (this.oneFormBatch[0].otPrice > 0) this.$set(val, 'otPrice', this.oneFormBatch[0].otPrice);
      if (this.oneFormBatch[0].barCode) this.$set(val, 'barCode', this.oneFormBatch[0].barCode);
      if (this.oneFormBatch[0].stock >= 0) this.$set(val, 'stock', this.oneFormBatch[0].stock);
      if (this.oneFormBatch[0].weight >= 0) this.$set(val, 'weight', this.oneFormBatch[0].weight);
      if (this.oneFormBatch[0].volume >= 0) this.$set(val, 'volume', this.oneFormBatch[0].volume);
      if (this.oneFormBatch[0].brokerage > 0) this.$set(val, 'brokerage', this.oneFormBatch[0].brokerage);
      if (this.oneFormBatch[0].brokerageTwo > 0) this.$set(val, 'brokerageTwo', this.oneFormBatch[0].brokerageTwo);
      if (this.oneFormBatch[0].vipPrice > 0) this.$set(val, 'vipPrice', this.oneFormBatch[0].vipPrice);
      if (this.oneFormBatch[0].itemNumber) this.$set(val, 'itemNumber', this.oneFormBatch[0].itemNumber);
    },
    // 添加按钮
    addBtn: function addBtn() {
      this.clearAttr();
      this.isBtn = true;
    },
    clearAttr: function clearAttr() {
      this.formDynamic.attrsName = '';
      this.formDynamic.attrsVal = '';
    },
    // 删除规格
    handleRemoveRole: function handleRemoveRole(index) {
      this.formValidate.attrs.splice(index, 1);
      this.ManyAttrValue.splice(index, 1);
      if (!this.formValidate.attrs.length) {
        this.formValidate.header = [];
        this.ManyAttrValue = [];
      } else {
        this.generateAttr(this.formValidate.attrs);
      }
    },
    // 添加属性
    createAttr: function createAttr(num, idx) {
      var _this10 = this;
      if (num) {
        // 判断是否存在同样熟悉
        var isExist = this.formValidate.attrs[idx].detail.some(function (item) {
          return item.value === num;
        });
        if (isExist) {
          this.$message.error('规格值已存在');
          return;
        }
        this.formValidate.attrs[idx].detail.push({
          value: num,
          image: ''
        });
        if (this.ManyAttrValue.length) {
          this.addOneAttr(this.formValidate.attrs[idx].value, num);
        } else {
          this.generateAttr(this.formValidate.attrs);
        }
        this.$refs['popoverRef_' + idx][0].doClose(); //关闭的
        this.clearAttr();
        setTimeout(function () {
          if (_this10.$refs['popoverRef_' + idx]) {
            //重点是以下两句
            _this10.$refs['popoverRef_' + idx][0].doShow(); //打开的
            //重点是以上两句
          }
        }, 20);
      } else {
        this.$refs['popoverRef_' + idx][0].doClose(); //关闭的
      }
    },
    //清空卡密
    virtualListClear: function virtualListClear() {
      // this.$set(this[this.carMytabName][this.carMytabIndex], 'cdkey', []);
      this[this.carMytabName][this.carMytabIndex].cdkeyId = [];
    },
    //添加倒入卡密的值
    changeVirtual: function changeVirtual(e) {
      this.virtualList = this.virtualList.concat(e);
    },
    closeCloudDisk: function closeCloudDisk() {
      this.$refs.cloudDiskRef.cloudDiskShow = false;
    },
    //确认保存云盘链接
    handlerSubSuccessCloudDisk: function handlerSubSuccessCloudDisk(e) {
      this.cloudDisk = e;
      this[this.carMytabName][this.carMytabIndex].expand = JSON.parse(JSON.stringify(e));
      this.$refs.cloudDiskRef.cloudDiskShow = false;
    },
    //选择卡密库回调
    handlerChangeCdkeyIdSubSuccess: function handlerChangeCdkeyIdSubSuccess(row) {
      this[this.carMytabName][this.carMytabIndex].cdkeyLibraryName = row.name;
      this[this.carMytabName][this.carMytabIndex].cdkeyId = row.id;
      this[this.carMytabName][this.carMytabIndex].stock = row.stock;
    },
    //查看已设置的虚拟团购券
    seeVirtually: function seeVirtually(data, name, index, type) {
      this.carMytabName = name;
      this.carMytabIndex = index;
      if (type === 1) {
        this.cloudDisk = data.expand;
        this[this.carMytabName][this.carMytabIndex].expand = data.expand;
        this.$refs.cloudDiskRef.cloudDiskShow = true;
      } else {
        this.cdkeyLibraryInfo = {
          id: data.cdkeyId,
          name: data.cdkeyLibraryName
        };
        this.$refs.cdkeyLibraryRef.cdkeyShow = true;
      }
    },
    // 添加虚拟链接
    handleAddVirtually: function handleAddVirtually(index, name, type) {
      this.carMytabIndex = index;
      this.carMytabName = name;
      //this.virtualListClear();
      if (type === 1) {
        this.cloudDisk = '';
        this.$refs.cloudDiskRef.cloudDiskShow = true;
      } else {
        this.cdkeyLibraryInfo = {};
        this.$refs.cdkeyLibraryRef.cdkeyShow = true;
      }
    }
  }
};